/* @flow */
import * as React from 'react';

import { Box, Flex, Footer } from '@sonyged/proc-ui';
import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';

import { CUSTOMER_WIDTH, HEIGHT, MIN_HEIGHT, MIN_WIDTH, WIDTH } from './Simulation/constants';
import type { Customer } from '../rules/types';
import { Customer as CustomerView } from './Simulation/Customer';
import { Mise01, Mise02, Mise03, MiseRepeat } from './Simulation/Background';
import { ScalableContainer } from './Simulation/ScalableContainer';
import { SushiContext } from '../SushiContext';
import Comment from '../components/Comment';
import SushiMenu from '../components/SushiMenu';

const offsetStyle = {
  transform: 'translate3d(0,-5%,0)',
};

const sitPositions = {
  '0': 'right',
  '1': 'middle',
  '2': 'left',
};

type Props = {
  customers: Customer[],
  onNext: Function,
  roundIndex: number,
};

export function WelcomeGuests(props: Props) {
  let { customers, onNext, roundIndex, ...rest } = props;

  let spring = useSpring({
    from: { opacity: 0, transform: 'translate3d(0,5%,0)' },
    to: { opacity: 1, transform: 'translate3d(0,0%,0)' },
    config: makeSpringConfig(0.3, 1),
  });

  const mapper = React.useContext(SushiContext);

  return (
    <>
      <Container {...rest}>
        <SushiMenu
          exitLink={mapper.getExitLink()}
          query={'?skip_intro=true'}
          title={''}
          subTitle={mapper.getTitle()}
          menuText={roundIndex + 1 + '組目'}
        />
        <MiseRepeat />
        <ScalableContainer
          flex={1}
          dWidth={WIDTH}
          dHeight={HEIGHT}
          dMinWidth={MIN_WIDTH}
          dMinHeight={MIN_HEIGHT}
          align="top"
        >
          <Mise01 />
          <AnimationContainer>
            {customers.map((customer, i) => (
              <CustomerView
                {...customer}
                key={i}
                style={offsetStyle}
                animating={false}
                isFinish={false}
                sit={customers.length === 1 ? 'middle' : sitPositions[i]}
              />
            ))}
          </AnimationContainer>
          <Mise02 />
          <Mise03 />
        </ScalableContainer>
        <Flex flexDirection="column" position="absolute" bottom={0} width="100%" bg="white">
          <Box position="relative" width="100%" maxWidth={1024} alignSelf="center">
            <AnimatedComment style={spring}>へいらっしゃい！</AnimatedComment>
          </Box>
          <Footer variant="raised" bg="white">
            <Footer.MainButton onClick={onNext}>つぎへ</Footer.MainButton>
          </Footer>
        </Flex>
      </Container>
    </>
  );
}

const Container = styled(Box)({
  flex: 1,
  minHeight: 0,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});
const AnimationContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: `${((CUSTOMER_WIDTH * 5) / WIDTH) * 100}%`,
  left: `${((WIDTH - 5 * CUSTOMER_WIDTH) / 2 / WIDTH) * 100}%`,
});

const makeSpringConfig = (frequency: number, damping: number) => ({
  mass: 1,
  tension: Math.pow((2 * Math.PI) / frequency, 2),
  friction: (4 * Math.PI * damping) / frequency,
});

const AnimatedComment = animated(Comment);
